import { apiFetch } from "../api/core";
import { useItemActionWithConfirmation } from "../api/useAction";
import { useNewItem, useEditItem2, EditItem2Cfg } from "../api/useNewItem";
import { useIntl } from "react-intl";

interface Config<T> {
  newRecordDefault: Partial<T>;
  // onNewRecordSaved?: (r: T) => void;
  // onEditRecordSaved?: (r: T) => void;
  getRecordApiPath: (item?: T) => string;
  editRecordSettings?: Partial<EditItem2Cfg<T>>;
  onAnySave?: () => void;
  removeMemoTrigger?: any;
}

export const useListItemActions =  <T extends Record<string, any>>(cfg: Config<T>) => {
  const { formatMessage } = useIntl();

  const newRecord = useNewItem<Partial<T>, T>(cfg.getRecordApiPath(), cfg.newRecordDefault);
  const editRecord = useEditItem2<T>({
    ...(cfg.editRecordSettings || {}),
    getApiPath: cfg.getRecordApiPath,
  });

  const removeRecord = useItemActionWithConfirmation(async (item: T) => {
    if(!cfg.getRecordApiPath) {
      return item;
    }
    
    await apiFetch(cfg.getRecordApiPath(item), "delete");
    if(cfg.onAnySave) {
      cfg.onAnySave();
    }
    editRecord.cancel();
    return item;
  }, {
    title: formatMessage({ id: "dictionaries.remove_title" }),
    confirmationLabel: formatMessage({ id: "common.delete" }),
    memoTrigger: cfg.removeMemoTrigger,
  });

  return {
    newRecord: {
      ...newRecord,
      save: async (x?: Partial<T>) => {
        const r = await newRecord.save(x);
        if(cfg.onAnySave) {
          cfg.onAnySave();
        }
        return r;
      }
    },
    editRecord: {
      ...editRecord,
      save: async (x?: Partial<T>) => {
        const r = await editRecord.save(x);
        if(cfg.onAnySave) {
          cfg.onAnySave();
        }
        return r;
      }
    },

    removeRecord,
  }
}
